import { render } from "./MedicalManage.vue?vue&type=template&id=19b8f91b"
import script from "./MedicalManage.vue?vue&type=script&lang=js"
export * from "./MedicalManage.vue?vue&type=script&lang=js"

import "./MedicalManage.vue?vue&type=style&index=0&id=19b8f91b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__